interface Props {
  title: string;
}

const INITIALS_LIMIT = 2;

export const Avatar = ({ title }: Props) => {
  const initials = title
    .split(' ')
    .slice(0, INITIALS_LIMIT)
    .map(word => word[0])
    .join('')
    .toUpperCase();

  return (
    <div className="flex size-10 items-center justify-center rounded-large bg-white">
      <span data-sentry-mask className="text-neutral-60 body-3" aria-hidden="true">
        {initials}
      </span>
    </div>
  );
};
